import React from 'react';

export default function Pagination({ totalPaginas, paginaAtual, onPageChange }) {
  const handlePrevious = () => paginaAtual > 1 && onPageChange(paginaAtual - 1);
  const handleNext = () => paginaAtual < totalPaginas && onPageChange(paginaAtual + 1);

  const renderPageNumbers = () => {
    const pages = [];
    const siblingCount = 2; // Número de páginas vizinhas
    const boundaryCount = 1; // Número de páginas no início e no fim

    const startPage = Math.max(1, paginaAtual - siblingCount);
    const endPage = Math.min(totalPaginas, paginaAtual + siblingCount);

    for (let i = 1; i <= boundaryCount; i++) if (i < startPage) pages.push(renderPageButton(i));

    if (startPage > boundaryCount + 1)
      pages.push(
        <span key="start-ellipsis" className="px-2">
          ...
        </span>
      );

    for (let i = startPage; i <= endPage; i++) pages.push(renderPageButton(i));

    if (endPage < totalPaginas - boundaryCount)
      pages.push(
        <span key="end-ellipsis" className="px-2">
          ...
        </span>
      );

    for (let i = totalPaginas - boundaryCount + 1; i <= totalPaginas; i++)
      if (i > endPage) pages.push(renderPageButton(i));

    return pages;
  };

  const renderPageButton = page => (
    <a
      key={page}
      onClick={() => onPageChange(page)}
      className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
        page === paginaAtual
          ? 'bg-indigo-600 text-white'
          : 'text-gray-900 ring-1 ring-gray-300 ring-inset hover:bg-gray-50'
      } focus:z-20 focus:outline-offset-0 cursor-pointer`}
    >
      {page}
    </a>
  );

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
      <div className="flex items-center justify-between w-full">
        <div>
          <p className="text-sm text-gray-700">
            Mostrando página
            <span className="font-medium">{` ${paginaAtual} `}</span>
            de
            <span className="font-medium">{` ${totalPaginas} `}</span>
          </p>
        </div>
        <div>
          <nav
            className="items-center isolate inline-flex -space-x-px rounded-md shadow-xs"
            aria-label="Pagination"
          >
            <a
              onClick={handlePrevious}
              className={`relative cursor-pointer inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${
                paginaAtual === 1 ? 'cursor-not-allowed opacity-50' : ''
              }`}
            >
              <span className="sr-only">Previous</span>
              <svg className="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
            {renderPageNumbers()}
            <a
              onClick={handleNext}
              className={`cursor-pointer relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${
                paginaAtual === totalPaginas ? 'cursor-not-allowed opacity-50' : ''
              }`}
            >
              <span className="sr-only">Next</span>
              <svg className="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
}
